<template>
    <div class="template-layout">
        <script type="application/ld+json">
            {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [{
                    "@type": "Question",
                    "name": "¿Como comprar?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Comprar en Tallo Verde es muy sencillo. Entras a nuestra web y elegís los productos de estación que querés. Dependiendo de tu domicilio podés elegir un día y horario de entrega. Elegís la forma de pago. Y listo!"
                    }
                }, {
                    "@type": "Question",
                    "name": "¿Los productos son frescos?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Todos nuestros productos se cosechan la mañana misma en la que recibis el pedido, de esta forma nuestros productos te llegan bien frescos para que los disfrutes."
                    }
                }, {
                    "@type": "Question",
                    "name": "¿Cuales son las zonas de entrega?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Podes consultar en nuestra web si llegamos a tu domicilio simplemente ingresando tu dirección."
                    }
                }]
            }
        </script>

        <script type="application/ld+json">
            {
                "@context": "https://schema.org",
                "@type": "Organization",
                "url": "https://www.talloverde.com",
                "logo": "https://www.talloverde.com/logo.png",
                "contactPoint": [{
                    "@type": "ContactPoint",
                    "telephone": "+54-0800-888-2556",
                    "contactType": "customer service",
                    "contactOption": "TollFree",
                    "areaServed": "AR"
                }]
            }
        </script>

        <template-nav-bar v-bind:is-black="scrolled" class="fixed-nav-bar"></template-nav-bar>

        <header class="header hero" :class="{ 'is-fullheight': fullheader }">
            <div class="hero-head">

            </div>

            <div class="hero-body">
                <slot name="header"></slot>
            </div>

            <div class="hero-foot"></div>
        </header>

        <div>
            <slot name="content"></slot>
        </div>

        <template-footer></template-footer>
    </div>
</template>

<script>
    import TemplateNavBar from './TemplateNavBar.vue';
    import TemplateFooter from './TemplateFooter.vue';

    export default {
        name: 'TemplateLayout',
        components: {
            TemplateNavBar,
            TemplateFooter
        },
        props: ['title', 'fullheader'],
        data() {
            return {
                scrolled: false
            }
        },

        created() {
            window.addEventListener('scroll', this.handleScroll);
        },

        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);
        },

        methods: {
            handleScroll() {
                this.scrolled = window.scrollY > 0;
            },
        }
    }
</script>

<style lang="scss" scoped>
    section {
        padding-top: 40px;
        padding-bottom: 40px;
    }

    .fixed-nav-bar {
        transition: all 0.25s;
        height: 82px;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 9;
        background-color: transparent;
    }

    .hero-body {
        position: relative;

        .box {
            .title {
                text-transform: none;
                font-style: normal;
                font-size: 1.5rem;
                text-align: center;
            }

            form {
                margin-top: 20px;
            }

            .button {
                width: 100%;
                margin-top: 20px;
            }
        }

        > .title {
            font-size: 3rem;
            font-weight: lighter;
            color: white;
            text-align: center;
            margin-top: 20px;
            padding: 20px;
            font-style: italic;

            &:after {
                content: none;
            }

            @include desktop {
                font-size: 5rem;
            }
        }

        .subtitle {
            color: #8fbc1b;
            font-size: 3rem;
            font-weight: bolder;
            z-index: 1;
        }
    }
</style>